import React, { useEffect, useRef } from 'react';

const LordIcon = ({ src, trigger, colors, size }) => {
  const elementRef = useRef(null);

  useEffect(() => {
    const loadIcon = async () => {
      if (elementRef.current) {
        const element = elementRef.current;
        // Set properties after a short delay to ensure proper initialization
        setTimeout(() => {
          element.src = src;
          element.trigger = trigger;
          element.colors = colors;
          element.state = 'in'; // Force initial state
        }, 100);
      }
    };

    loadIcon();
  }, [src, trigger, colors]);

  return (
    <lord-icon
      ref={elementRef}
      style={{
        width: size,
        height: size,
        display: 'inline-block', // Ensure visibility
        opacity: 1
      }}
      className="about__icon"
    />
  );
};

export default LordIcon;
